import React, { Component } from 'react';
import Dropdown from 'react-dropdown';

class NewParameterMod extends Component {
    get parameters() {
        return this.props.effect.parameters;
    }

    render() {
        return (
            <div className="new-parameter-mod">
              <ParametersDropdown parameters={this.parameters}/>
            </div>
        );
    }
}

class ParametersDropdown extends Component  {
    constructor(props) {
        super(props);

        this.state = {
            option: undefined,
        };
    }

    get options() {
        return this.props.parameters.map(
            parameter => ({
                value: parameter,
                label: parameter.name
            }
        ));
    }

    onChooseParameter(o) {
        this.setState({option: o});
    }

    render() {
        return (
            <Dropdown
              className='osc-type-dropdown'
              controlClassName='osc-type-control-dropdown'
              arrowClassName='osc-type-arrow-dropdown'
              options={this.options}
              onChange={(o) => this.onChooseParameter(o)}
              value={this.state.option}
              placeholder="Parameter" />
        );
    }
}

export default NewParameterMod;
